import { isEmbedded } from '../services/embedded/embeddedService';

// Single entry point for browser file downloads.
//
// In the embedded (cross-origin iframe) flow, a programmatic `a.click()` on a
// blob: URL is blocked by the frame sandbox, so we hand the Blob to the parent
// (Stigg), which performs the object-URL + click from the top window. The Blob
// is sent directly — it is structured-cloneable — rather than a URL, so the
// parent never needs Received's auth token (authTokenService) to re-fetch the
// file.
//
// The message contract is fixed by the parent listener and must not drift:
//   { type: 'received:download', fileName, blob }
// targetOrigin is '*' because the parent validates event.source against its own
// iframe's contentWindow, so only this frame can drive the download.
export const triggerDownload = (blob: Blob, fileName: string): void => {
	if (isEmbedded()) {
		window.parent.postMessage({ type: 'received:download', fileName, blob }, '*');
		return;
	}

	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
};
